// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { ProductFilterCountry } from "../../../../common/interfaces/conversionworld/ProductFilter";

@Component({
  mixins: [template],
})
export default class Countries extends Vue {
  @Prop({ default: false })
  public useKonsiFilter!: boolean;

  get filterStore() {
    if (this.useKonsiFilter) {
      return this.$store.conversionWorldKonsiFilter;
    }

    return this.$store.conversionWorldProductFilter;
  }

  get countries() {
    if (this.filterStore.filterData) {
      return this.filterStore.filterData.countries
        .filter((x) => x.count > 0)
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    return [];
  }

  private isChecked(country: ProductFilterCountry) {
    return this.filterStore.filter.countries.indexOf(country.id) >= 0;
  }

  private onInput(country: ProductFilterCountry, value) {
    if (value) {
      if (!this.isChecked(country)) {
        this.filterStore.addFilterTag("countries", country);
      }
    } else {
      this.filterStore.removeFilterTag("countries", country);
    }
  }
}
